module.exports = __webpack_public_path__ + "fonts/TTNormsPro-MediumItalic.ea829175.woff";